<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ header.title.key | translate: header.title.params }}</mat-card-title>
    <div class="subtitle-line1 stencil-shimmer"></div>
    <div class="subtitle-line2 stencil-shimmer"></div>
    <div class="subtitle-line3 stencil-shimmer"></div>
  </mat-card-header>

  @if (showGraphArea) {
    <div class="chart-container">
      <div class="chart-inner-container stencil-shimmer"></div>
    </div>
  }
</mat-card>
